export class SupplierModel {
  public supplier: string;
  public name: string;
  public streetAddress: string;
  public postalCode: string;
  public postOfficeBox: string;
  public postalCodePOBox: string;
  public city: string;
  public state: string;
  public debitor: string;
  public currency: string;
  public customerErrorMessages: string[];
}
